module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("For anyone who ever just got back up and went at it again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("For MJP. Always.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("For the service men and women who choose to risk their lives, intent on making our world a better place. Heroes all.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("…and for a once in a lifetime dog…")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0